import * as React from 'react'

import { cn } from './cn'

export interface BadgeProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> {
  badgeContent?: React.ReactNode
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
  invisible?: boolean
  variant?: 'standard' | 'dot'
  overlap?: 'circular' | 'rectangular'
}

const colorClasses = {
  primary: 'bg-primary text-primary-contrast',
  secondary: 'bg-primary text-primary-contrast',
  error: 'bg-error text-white',
  warning: 'bg-warning text-white',
  info: 'bg-info text-white',
  success: 'bg-success text-white',
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      badgeContent,
      color = 'primary',
      invisible,
      variant = 'standard',
      overlap,
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <span
      ref={ref}
      className={cn('relative inline-flex', className)}
      {...props}
    >
      {children}
      {!invisible && (badgeContent !== undefined || variant === 'dot') && (
        <span
          className={cn(
            'absolute -right-1.5 -top-1.5 z-10 flex items-center justify-center rounded-full',
            variant === 'dot'
              ? 'h-2 w-2'
              : 'h-5 min-w-[20px] px-1 text-xs font-semibold',
            'ring-2 ring-paper',
            colorClasses[color],
          )}
        >
          {variant !== 'dot' && badgeContent}
        </span>
      )}
    </span>
  ),
)
Badge.displayName = 'Badge'

export default Badge
